import { rem, rgba, size } from "polished";
import styled, { css } from "styled-components";
import media from "styled-media-query";

import { themes } from "styles";

import { Container as ContainerComponent } from "../Container";

type ItemProps = {
  done?: boolean;
  active?: boolean;
};

export const Container = styled(ContainerComponent)`
  border-radius: 12px;
  border: 1px solid #edf3f5;
  box-shadow: 0 4px 4px ${rgba("#000", 0.01)};
`;

export const List = styled.div`
  padding: 7px 10px;

  display: flex;
`;

export const Icon = styled.div`
  padding: 10px;

  line-height: 0;
  border-radius: 8px;
  color: ${themes.text.lower};

  ${media.greaterThan("huge")`
    padding: 16px;

    border-radius: 12px;
  `}

  > svg {
    ${size("14px")}

    ${media.greaterThan("huge")`
      ${size("20px")}
    `}
  }
`;

export const Item = styled.div<ItemProps>`
  display: flex;
  align-items: center;

  ${({ done }) =>
    done &&
    css`
      cursor: pointer;

      &:hover {
        ${Icon} {
          transition: background-color 0.15s;
          background-color: ${rgba(themes.palletes.primary, 0.2)};
        }
      }

      ${Icon} {
        color: ${themes.palletes.primary};
        transition: background-color 0.15s;
        background-color: ${rgba(themes.palletes.primary, 0.1)};
      }
    `}

  ${({ active }) =>
    active &&
    css`
      ${Icon} {
        color: #fff;
        background-color: ${themes.palletes.primary};
        box-shadow: 0 2px 12px ${rgba(themes.palletes.primary, 0.2)};
      }
    `}

  &:not(:last-of-type) {
    margin-right: 8px;

    ${media.greaterThan("large")`
      margin-right: 16px;
    `}

    &:after {
      width: 1px;
      height: 60%;
      margin-left: 8px;

      display: block;

      content: "";
      background-color: #edf3f5;

      ${media.greaterThan("large")`
        margin-left: 16px;
      `}
    }
  }
`;

export const Detail = styled.div`
  margin-left: 8px;
`;

export const Step = styled.p`
  font-size: ${rem("7px")};
  color: ${themes.palletes.primary};

  ${media.greaterThan("huge")`
    font-size: ${rem("12px")};
  `}
`;

export const Title = styled.p`
  margin-top: 2px;

  font-weight: bold;
  line-height: 120%;
  font-size: ${rem("10px")};
  color: ${themes.text.higher};

  ${media.greaterThan("huge")`
    font-size: ${rem("15px")};
  `}
`;
